<template>
<div>
	<div class="d-flex justify-content-between mb-2">
		<h3 style="margin-bottom: 0">
			<i v-if="showCollapseButton" v-on:click="$emit('collapseTreePanel')" class="fa fa-chevron-right icon-button"></i>
			Bid Structure Tree
		</h3>
		<a :href="'/project-bid-tree/' + $route.params.tag" target="_blank">Open Bid Summary in Separate Tab</a>
	</div>
	<div>
		<bid-tree-node v-if="nestedBid" :component="nestedBid" :selected-component-id="selectedComponentId"></bid-tree-node>
	</div>
</div>
</template>
<script type="text/javascript">
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

import BidTreeNode from "./BidTreeNode.vue"

export default {
	name: "ProjectBidTree",
	components: {
		BidTreeNode
	},
	mixins: [ProjectBidMixins],
	props: [
		"bidProp",
		"selectedComponentId",
		"showCollapseButton"
	],
	data() {
		return {
			nestedBid: null
		}
	},
	watch: {
		bidProp() {
			if (this.bidProp && "id" in this.bidProp)
				this.fetchAllComponents(this.bidProp.id)
		},
		'$store.projectBidObjects'() {
			if (this.bidProp && "id" in this.bidProp)
				this.fetchAllComponents(this.bidProp.id)
		}
	},
	methods: {

	},
	created() {
		let vm = this
		this.fetchAllComponents(this.bidProp.id)

		this.getJSON("JobBid/get-whole-bid",{bid_id: this.bidProp.id}).then(response => {
			if (response.success)
				vm.nestedBid = response.data
		})
	}
}	
</script>